import { differenceInCalendarDays } from 'date-fns';

import { EFlightStatus, ETripEvent } from 'detailsv2/structure';
import { getLocalDateFromString } from 'utils/date';

import { CalendarEvent } from './types';

export const getUpdatedSelectedEvents = (
  selectedEvents: CalendarEvent[],
  draggingStartDay: number,
  dropDay: number,
): CalendarEvent[] => {
  const MIN_DAY = 1;
  const offset = dropDay - draggingStartDay;

  const updatedSelectedEvents = selectedEvents.map((event) => {
    const eventLength = event.daysRange.end ? event.daysRange.end - event.daysRange.start : 1;

    const updatedStart = Math.max(event.daysRange.start + offset, MIN_DAY);
    const updatedEnd = updatedStart + eventLength;

    return { ...event, daysRange: { start: updatedStart, end: updatedEnd } };
  });

  return updatedSelectedEvents;
};

/**
 * Helper function for displaying the error (blinking) state of {@link EventPlank}.
 * @returns In case of true, the plank will blink; false otherwise.
 */
export const checkForErrors = (event: CalendarEvent) => {
  switch (event.type) {
    case ETripEvent.Flight:
      if (
        event.data.fromFsService &&
        differenceInCalendarDays(getLocalDateFromString(event.data.flightDate), new Date()) >= 0
      ) {
        // Should blink if the status is "rescheduled" or "cancelled"
        return event.data.flightStatus !== EFlightStatus.Common;
      }
      return false;
    default:
      return false;
  }
};
